import Button from '../../components/form-control/Button';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import { changeAccessRight } from '../../api/requests';
import SelectDropdown, { ISelectDropdownItem } from '../../components/form-control/SelectDropdown';
import { ACCESS_RIGHTS, SELECTABLE_ACCESS_RIGHTS } from '../../resources/enums';
import { getFormattedAccessRight, showToast } from '../../utils/miscFunctions';
import useUserAccount from '../../hooks/userAccountHook';

export interface IChangeAccessRight {
  staffID: string;
  accessRight: ACCESS_RIGHTS;
}

const accessRights: Array<ISelectDropdownItem> = SELECTABLE_ACCESS_RIGHTS.map(
  (value) => ({
    name: getFormattedAccessRight(value),
    value: value
  })
);

const ChangeAccessRight = ({ onProceed, onClose, staffID }: { onProceed: () => void; onClose: () => void; staffID: string }) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { user } = useUserAccount();

  const submitHandler = (values: any) => {
    setSubmitting(true);
    const payload: IChangeAccessRight = {
      staffID: staffID,
      accessRight: values.accessRight
    };

    if (staffID)
      changeAccessRight(payload)
        .then((response: any) => {
          showToast.success(response.message ?? 'Admin access has been updated successfully');
          onProceed();
        })
        .catch((error: any) => {
          showToast.error(error.description);
        })
        .finally(() => setSubmitting(false));
  };

  return (
    <div className="bg-white dark:bg-darkBg p-5 rounded-xl">
      <h3 className="text-center px-4 dark:text-darkBg-mainText">Select a new role for this user</h3>

      <div className="p-[1rem] w-full">
        <Formik
          initialValues={{
            accessRight: ''
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={Yup.object({
            accessRight: Yup.string().required('Role is required.')
          })}
          onSubmit={(values) => {
            submitHandler(values);
          }}>
          {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
            <form className="space-y-5" onSubmit={handleSubmit}>
              <div className="">
                <SelectDropdown
                  name="accessRight"
                  list={accessRights}
                  listSelectedValue={values.accessRight}
                  onChange={(val: ISelectDropdownItem | null) => {
                    setFieldValue('accessRight', val);
                  }}
                  onBlur={handleBlur}
                  placeholder="Select a role"
                  error={touched.accessRight ? errors.accessRight : undefined}
                  helperText={touched?.accessRight ? errors.accessRight : undefined}
                  required
                />
              </div>

              <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                  disabled={submitting}
                />
                <Button
                  type="submit"
                  label="Submit"
                  bgColor='primary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>

            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ChangeAccessRight;
